import React, { useEffect, useMemo } from 'react';
import MotorTpiCertificate from '../components/MotorTpiCertificate';
import { readMotorCertificatePrint } from '../pulsePrint';
import '../styles/motor-certificate.css';

function MotorCertificatePrint() {
    const payload = useMemo(() => readMotorCertificatePrint(), []);
    const certificates = (payload && payload.certificates) || (payload && payload.policy ? [payload] : []);

    useEffect(() => {
        if (!certificates.length) return;
        const t = window.setTimeout(() => window.print(), 800);
        return () => window.clearTimeout(t);
    }, [certificates.length]);

    if (!certificates.length) {
        return (
            <div className="tpi-print-root">
                <p>No certificate is ready to print.</p>
            </div>
        );
    }

    return (
        <div className="tpi-print-root">
            <div className="tpi-toolbar no-print">
                <button type="button" className="btn btn-primary" onClick={() => window.print()}>Print certificate</button>
            </div>
            {certificates.map((row, i) => (
                <MotorTpiCertificate
                    key={(row.policy && row.policy.id) || i}
                    policy={row.policy}
                    customer={row.customer}
                    managerName={row.managerName}
                    examinedBy={row.examinedBy}
                    issuedAt={row.issuedAt}
                    signature={row.signature}
                />
            ))}
        </div>
    );
}

export default MotorCertificatePrint;
